var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "p-3 custom-bg mt-3" },
    [
      _c("validation-observer", {
        ref: "addContractObserver",
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function({ validate, reset }) {
              return [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("label", { staticClass: "font-weight-bolder" }, [
                      _vm._v("Añadir otro Contrato")
                    ])
                  ]),
                  _c(
                    "div",
                    { staticClass: "col-3 my-3" },
                    [
                      _c("ValidationProvider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-drop-down", {
                                    attrs: {
                                      clearable: true,
                                      "custom-error-msg":
                                        "El campo es requerido",
                                      error: errors[0],
                                      fieldkey: "id",
                                      fieldname: "name",
                                      label: "Proveedor",
                                      options: _vm.contractors
                                    },
                                    model: {
                                      value: _vm.model.provider,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "provider", $$v)
                                      },
                                      expression: "model.provider"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-3 my-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      label: "Número de Contrato",
                                      placeholder: "Número de Contrato"
                                    },
                                    model: {
                                      value: _vm.model.contractNumber,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "contractNumber",
                                          $$v
                                        )
                                      },
                                      expression: "model.contractNumber"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-3 my-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      label: "Cuantía del Contrato Vigente",
                                      "mask-type": "Money",
                                      placeholder:
                                        "Cuantía del Contrato Vigente"
                                    },
                                    model: {
                                      value: _vm.model.currentAmount,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "currentAmount",
                                          $$v
                                        )
                                      },
                                      expression: "model.currentAmount"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-3 my-3" },
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required|min_value:0" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function({ errors }) {
                                return [
                                  _c("custom-input", {
                                    attrs: {
                                      "custom-error-msg":
                                        "El campo es requerido.",
                                      error: errors[0],
                                      label: "Enmiendas previamente otorgadas",
                                      min: 0,
                                      placeholder:
                                        "Enmiendas previamente otorgadas",
                                      type: "number"
                                    },
                                    model: {
                                      value: _vm.model.amendmentsGranted,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "amendmentsGranted",
                                          $$v
                                        )
                                      },
                                      expression: "model.amendmentsGranted"
                                    }
                                  })
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-12 d-flex justify-content-end my-3" },
                    [
                      _c("action-button", {
                        staticClass: "mr-2 px-3",
                        attrs: {
                          i: "fas fa-times-circle",
                          text: "Cancelar",
                          variant: "outline-danger"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onCancel(reset)
                          }
                        }
                      }),
                      _c("action-button", {
                        staticClass: "mr-2 px-3",
                        attrs: {
                          i: "fas fa-file-plus",
                          text: "Añadir",
                          variant: "success"
                        },
                        on: {
                          click: function($event) {
                            return _vm.onSubmit(validate, reset)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }